module.exports = __webpack_public_path__ + "static/media/oldVersion.5e1595dd.png";